<template>
<div class="commnent-wrapper">
  <div class="comment-inner">
    <div class="comment-header">
      <div class="comment-avatar">
        <div class="avatar-left">
          <div class="avatar">
            <img :src="info.avatar||require('../../../assets/course/avatar_default.png')" alt="">
          </div>
          <div class="avatar-name">
            <p class="name">{{info.nickName}}</p>
            <vanRate v-model="rateValue" allow-half void-icon="star" void-color="#eee" readonly size="15px">

            </vanRate>
          </div>
        </div>
        <div class="avatar-right">
          <span>{{info.createTime}}</span>
        </div>
      </div>
    </div>
    <div class="comment-body">
      <vanTag plain color="#ed5b68" round text-color="#ed5b68" size="large" v-for="(item,index) in getTags" :key="index">{{item}}</vanTag>
    </div>
  </div>
</div>
</template>
<script>
import Rate from 'vant/lib/rate'
import 'vant/lib/rate/style'
import Tag from 'vant/lib/tag'
import 'vant/lib/tag/style'
export default {
  name: 'comment',
  components: {
    vanRate: Rate,
    vanTag: Tag
  },
  props: ['info'],
  data() {
    return {
      // rateValue:2.5
    }
  },
  computed: {
    rateValue() {
      return this.info.level
    },
    getTags() {
      if (!this.info.comment) return []
      return this.info.comment.split('|')
    }
  },
}
</script>
<style lang="scss">
.commnent-wrapper {
    width: 100%;

    margin-bottom: 25px;
    .comment-inner {
        padding-bottom: 20px;
        padding-right: 16px;
        border-bottom: 1px solid #e1e1e1;
        .comment-header {
            margin-bottom: 26px;
        }
        .comment-body {
            text-align: left;
            .van-tag {
                margin-right: 6px;
                margin-bottom: 6px;
                background-color: #f8e9ea;
                padding-left: 5px;
                padding-right: 5px;
                border-width: 1px;
            }
        }
        .comment-avatar {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .avatar-left {
                display: flex;
                align-items: center;
                .avatar {
                    width: 38px;
                    height: 38px;
                    border-radius: 38px;
                    overflow: hidden;
                    margin-right: 6px;
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
                .avatar-name {
                    font-size: 14px;
                    color: #222222;
                    text-align: left;

                    .name {
                        margin-bottom: 4px;

                    }
                }
            }
            .avatar-right {
                font-size: 12px;
                color: #999999;
            }
        }
    }
}
</style>
